"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReferralSaleLoader = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var useReferralSaleContract_1 = require("../../../../contracts/useReferralSaleContract");
var types_1 = require("../../../../pool/types");
var utils_1 = require("../../../../shared/utils");
var utils_2 = require("./utils");
var SALE_RATE_DIVIDER = 1e6;
var toStatus = function (v) {
    if (v === useReferralSaleContract_1.TimelineStatus.PreRegister)
        return types_1.SaleStatus.preRegister;
    if (v === useReferralSaleContract_1.TimelineStatus.Register)
        return types_1.SaleStatus.register;
    if (v === useReferralSaleContract_1.TimelineStatus.Prepare)
        return types_1.SaleStatus.init;
    if (v === useReferralSaleContract_1.TimelineStatus.Live)
        return types_1.SaleStatus.open;
    if (v === useReferralSaleContract_1.TimelineStatus.Fcfs)
        return types_1.SaleStatus.open;
    if (v === useReferralSaleContract_1.TimelineStatus.Ended)
        return types_1.SaleStatus.finished;
    return types_1.SaleStatus.static;
};
var ReferralSaleLoader = /** @class */ (function () {
    function ReferralSaleLoader(web3, config, instance) {
        this.web3 = web3;
        this.config = config;
        this.instance = instance;
    }
    ReferralSaleLoader.prototype.fetchAll = function () {
        var _this = this;
        return Promise.all([
            this.instance.methods.getSaleState().call(),
            this.instance.methods.getSaleTimeline().call(),
        ]).then(function (_a) {
            var saleState = _a[0], saleTimeline = _a[1];
            return __assign(__assign({}, _this.config), { status: toStatus((0, utils_2.toNumber)(saleState.status)), rate: (0, utils_2.toNumber)(saleState.rate) / SALE_RATE_DIVIDER, initRate: (0, utils_2.toNumber)(saleState.initRate) / SALE_RATE_DIVIDER, isSoftCap: saleState.isSoftCap, tokensForSale: (0, utils_2.toBN)(saleState.tokensForSale), tokensSold: (0, utils_2.toBN)(saleState.tokensSold), raised: (0, utils_2.toBN)(saleState.raised), participants: (0, utils_2.toNumber)(saleState.participants), limits: { min: (0, utils_2.toBN)(saleState.minSell), max: (0, utils_2.toBN)(saleState.maxSell) }, hasWhitelist: (0, utils_2.toNumber)(saleState.whitelistedCount) > 0, startDate: dayjs_1.default.unix((0, utils_2.toNumber)(saleTimeline.startTime)).toISOString(), durationHours: (0, utils_2.toNumber)(saleTimeline.duration) / 60 / 60, fcfsDuration: (0, utils_2.toNumber)(saleTimeline.fcfsDuration) / 60 / 60 });
        });
    };
    ReferralSaleLoader.prototype.fetchInit = function () {
        var _this = this;
        return this.fetchAll().then(function (data) {
            _this.config = data;
            return data;
        });
    };
    ReferralSaleLoader.prototype.fetchRegular = function () {
        var _this = this;
        return this.fetchAll().then(function (data) {
            _this.config = data;
            return data;
        });
    };
    ReferralSaleLoader.prototype.fetchUser = function (account) {
        return (0, utils_1.call)(this.instance, 'getUserState', [account]).then(function (state) { return (__assign(__assign({}, (0, utils_2.cleanObjKeys)(state)), { weight: (0, utils_2.toNumber)(state.weight), contributed: (0, utils_2.toBN)(state.contributed), balance: (0, utils_2.toBN)(state.balance), totalAlloc: (0, utils_2.toBN)(state.totalAlloc), wlAlloc: (0, utils_2.toBN)(state.wlAlloc), fcfsAlloc: (0, utils_2.toBN)(state.fcfsAlloc), levelAlloc: (0, utils_2.toBN)(state.levelAlloc) })); });
    };
    return ReferralSaleLoader;
}());
exports.ReferralSaleLoader = ReferralSaleLoader;
